import FontelloIcon from '@sport1/news-styleguide/FontelloIcon'
import Sport1Logo from '@sport1/news-styleguide/Sport1Logo'
import Touchable from '@sport1/news-styleguide/Touchable'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import React, { FC, memo } from 'react'
import { spacings } from '@sport1/news-styleguide/spacings'
import { useTheme } from 'styled-components'
import { ThemeProps } from '@sport1/news-styleguide/Types'

type BurgerMenuHeaderProps = {
    onBack?: () => void
    onClose: () => void
}

export const BurgerMenuHeader: FC<BurgerMenuHeaderProps> = ({ onBack, onClose }) => {
    const { themeName } = (useTheme() as ThemeProps['theme']) || {}

    return (
        <NonFlexingContainer
            testID="burger-menu-header-wrapper"
            horizontal
            centerVertical
            paddingX="spacing-6"
            paddingTop="spacing-6"
        >
            {onBack ? (
                <>
                    <Touchable testID="burger-menu-back-icon" onPress={onBack}>
                        <FontelloIcon name="arrow_back_ios_new" color="onyx" fontSize="FS18" />
                    </Touchable>
                </>
            ) : (
                <Sport1Logo
                    type={themeName === 'dark' ? 'OnDark' : 'OnLight'}
                    testID="burger-menu-home-logo"
                    width={100}
                    href="/"
                />
            )}
            <NonFlexingContainer marginLeft="auto">
                <Touchable
                    marginRight={spacings['spacing-4']}
                    testID="burger-menu-close-icon"
                    onPress={onClose}
                >
                    <FontelloIcon name="close" color="onyx" fontSize={24} />
                </Touchable>
            </NonFlexingContainer>
        </NonFlexingContainer>
    )
}

export default memo(BurgerMenuHeader)
